
import { ReactNode, forwardRef } from 'react';
import { ISection } from '../../models/ISection';
import SectionDivider from '../components/SectionDivider';
import { twMerge } from 'tailwind-merge';
import ArticleBrief from '../components/ArticleBrief';
import Link from 'next/link';

const PostsSection = forwardRef(({
  locale,
  showDivider = true,
  showTitle = true,
  title,
  className,
  wrapperClassName,
  posts,
  customDivider,
  targetSlug,
  targetType,
  automated,
  device,
  clickableTitle,
  eager
}: Partial<ISection> & { locale: string, category: string; showDivider?: boolean; customDivider?: ReactNode; className?: string; wrapperClassName?: string; device?: string; }, ref: any) => {

  const TitleJsx = () => {
    if (!showTitle || !title) return null;
    if (clickableTitle) {
      return (
        <Link title={title} hrefLang={locale} href={`/${targetSlug}`} className='w-fit'><h2 className='text-primary-300 dark:text-white leading-[150%] tablet:leading-[155%] desktop:leading-[133%] w-full text-center desktop:w-fit desktop:text-start mb-[24px] pr-[16px] desktop:pr-[24px]'>{title}</h2></Link>
      )
    }
    else {
      return (
        <div title={title}  className='w-fit'><h2 className='text-primary-300 dark:text-white leading-[150%] tablet:leading-[155%] desktop:leading-[133%] w-full text-center desktop:w-fit desktop:text-start mb-[24px] pr-[16px] desktop:pr-[24px]'>{title}</h2></div>
      )
    }
  }
  return (
    <div ref={ref} className={twMerge('flex flex-col mb-[24px]', wrapperClassName)}>
      {showDivider ? (customDivider || <SectionDivider />) : null}
      <TitleJsx/>
      <div className={twMerge('home-posts', className)}>
        {posts?.map(p => <ArticleBrief device={device} locale={locale} key={p.uniqueCode} data={{ eager, post: p, category: {...p.category, uniqueCode: !automated || targetType === 1 ? p.category.uniqueCode : targetSlug! } }} hideCategory hideMeta />)}
      </div>
    </div>
  )
})


export default PostsSection;